import { initI18n, t } from './modules/i18n.js';
import { authHeaders } from './modules/auth.js';
import { unwrapPayload } from './modules/payload.js';
import { renderChart } from './modules/renderer.js';
import { addTOCEntry } from './modules/toc.js';

async function fetchJson(url) {
    const response = await fetch(url, { headers: authHeaders() });
    if (!response.ok) throw new Error(`HTTP ${response.status} for ${url}`);
    const raw = await response.json();
    return unwrapPayload(
        raw,
        window.OMA_CONFIG?.data_token,
        window.OMA_CONFIG?.data_ts,
    );
}

function containerId(index) {
    return `chart-container-${index}`;
}

function canvasId(index) {
    return `myChart${index}`;
}

function titleId(index) {
    return `chart-title-${index}`;
}

function chartTitle(spec, payload) {
    const base = t(spec.title_i18n, spec.key);
    const summary = payload?.summary?.display_text || '';
    if (spec.key === 'ai_competition') {
        return summary ? `${base}: ${summary}` : base;
    }
    const unit = spec.y_axis_title || '';
    return summary ? `${base}: ${summary}${unit ? ` ${unit}` : ''}` : base;
}

function setTitle(index, spec, payload) {
    const titleElement = document.getElementById(titleId(index));
    if (!titleElement) return;
    titleElement.textContent = chartTitle(spec, payload);
}

function setError(index, spec, messageKey) {
    const titleElement = document.getElementById(titleId(index));
    if (!titleElement) return;
    const base = t(spec.title_i18n, spec.key);
    titleElement.textContent = `${base}: ${t(messageKey, 'Data unavailable')}`;
}

function updateTimestampIfNeeded(spec, payload) {
    if (spec.key !== 'BTC') return;
    const latest = payload?.labels?.[payload.labels.length - 1];
    if (!latest) return;

    const parsedDate = new Date(latest);
    if (Number.isNaN(parsedDate.getTime())) return;

    const updateParagraph = document.getElementById('dynamic-update-paragraph');
    if (!updateParagraph) return;
    updateParagraph.textContent = `Updated ${parsedDate.getFullYear()}.${parsedDate.getMonth() + 1}.${parsedDate.getDate()}`;
}

async function loadPayload(spec, bundle) {
    if (bundle.errors?.[spec.key] || !bundle.items?.[spec.key]) {
        return fetchJson(`/data/proxy/data/${spec.key}`);
    }
    return bundle.items[spec.key];
}

async function renderOne(index, spec, bundle) {
    if (!document.getElementById(containerId(index))) return;

    try {
        const payload = await loadPayload(spec, bundle);
        setTitle(index, spec, payload);
        updateTimestampIfNeeded(spec, payload);
        addTOCEntry(t(spec.title_i18n, spec.key), payload?.summary?.display_text || '', `#${containerId(index)}`);
        renderChart(canvasId(index), spec, payload);
    } catch (error) {
        console.error(`[data_charts] Failed to render ${spec.key}:`, error);
        setError(index, spec, 'errors.network');
    }
}

document.addEventListener('DOMContentLoaded', async function () {
    await initI18n();

    try {
        const manifest = await fetchJson('/data/proxy/manifest');
        const bundle = await fetchJson(`/data/proxy/bundle?v=${manifest.version}`);
        await Promise.all((manifest.charts || []).map((spec, index) => renderOne(index, spec, bundle)));
    } catch (error) {
        console.error('[data_charts] Failed to initialize data charts:', error);
        const firstTitle = document.getElementById(titleId(0));
        if (firstTitle) {
            firstTitle.textContent = t('errors.network', 'Network Request Failed');
        }
    }
});
